var Common;
(function (Common) {
    var Map;
    (function (Map) {
        var addressIcon = "https://mcdcdn.blob.core.windows.net/map-icons/markers/blank.png";
        var australiaLatLng = new google.maps.LatLng(-25.610111, 134.354806);
        var australiaZoom = 10;
        var Location = /** @class */ (function () {
            function Location() {
            }
            return Location;
        }());
        Map.Location = Location;
        ;
        var Autocomplete = /** @class */ (function () {
            function Autocomplete() {
            }
            return Autocomplete;
        }());
        Map.Autocomplete = Autocomplete;
        var Geocode = /** @class */ (function () {
            function Geocode() {
            }
            return Geocode;
        }());
        Map.Geocode = Geocode;
        ;
        var MarkerLocation = /** @class */ (function () {
            function MarkerLocation() {
            }
            return MarkerLocation;
        }());
        Map.MarkerLocation = MarkerLocation;
        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        }
        function getDistanceBetweenPoints(lat1, lon1, lat2, lon2) {
            var R = 6371; // Radius of the earth in km
            var dLat = deg2rad(lat2 - lat1); // deg2rad below
            var dLon = deg2rad(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c; // Distance in km
            return d;
        }
        function convertLocation(formattedAddress, addressComponents, types, latLng) {
            var suburb = '';
            var num = '';
            var route = '';
            var addr = '';
            var state = '';
            var postcode = '';
            var country = '';
            var premise = '';
            var subpremise = '';
            var establishment = '';
            for (var i = 0; i < addressComponents.length; i++) {
                var comp = addressComponents[i];
                if (comp.types.indexOf("premise", 0) !== -1)
                    premise = comp.long_name;
                else if (comp.types.indexOf("subpremise", 0) !== -1)
                    subpremise = comp.long_name;
                else if (comp.types.indexOf("establishment", 0) !== -1)
                    establishment = comp.long_name;
                else if (comp.types.indexOf("street_address", 0) !== -1)
                    addr = comp.long_name;
                else if (comp.types.indexOf("street_number", 0) !== -1)
                    num = comp.long_name;
                else if (comp.types.indexOf("route", 0) !== -1)
                    route = comp.long_name;
                else if (comp.types.indexOf("locality", 0) !== -1)
                    suburb = comp.long_name;
                else if (comp.types.indexOf("administrative_area_level_1", 0) !== -1)
                    state = comp.short_name;
                else if (comp.types.indexOf("postal_code", 0) !== -1)
                    postcode = comp.short_name;
                else if (comp.types.indexOf("country", 0) !== -1)
                    country = comp.long_name;
            }
            if (addr.length === 0) {
                addr = $.trim(num + " " + route);
            }
            // Look for text like Brunswick St & McLachlan St, Fortitude Valley QLD 4006, Australia
            if (types.indexOf("intersection", 0) !== -1) {
                var ampersand = formattedAddress.indexOf("&", 0);
                var comma = formattedAddress.indexOf(",", 0);
                if (ampersand > 0 && comma > ampersand) {
                    addr = "Cnr of " + $.trim(formattedAddress.substring(0, comma));
                }
            }
            if (addr.length > 0 || suburb.length > 0) {
                var result = {
                    building: $.trim(subpremise + " " + premise + " " + establishment),
                    address: addr,
                    suburb: suburb,
                    postcode: postcode,
                    state: state,
                    country: country,
                    latLng: latLng
                };
                return result;
            }
            return null;
        }
        function convertPlace(place) {
            if (place && place.geometry && place.geometry.location) {
                return convertLocation(place.formatted_address, place.address_components, place.types, place.geometry.location);
            }
            return undefined;
        }
        function convertGeocoder(result) {
            if (result && result.geometry && result.geometry.location) {
                return convertLocation(result.formatted_address, result.address_components, result.types, result.geometry.location);
            }
            return undefined;
        }
        function InitAutoComplete(inputElem, mapElem) {
            var auto = $(inputElem).data("auto-obj");
            if (!auto) {
                var input = $(inputElem).get(0);
                var autocomplete = new google.maps.places.Autocomplete(input, { componentRestrictions: { country: 'au' } });
                $(inputElem).data("auto-obj", autocomplete);
                google.maps.event.addListener(autocomplete, 'place_changed', function () {
                    var place = autocomplete.getPlace();
                    if (!place || !place.geometry)
                        return;
                    if (mapElem && $(mapElem).is(":visible")) {
                        var map = $(mapElem).data("map-obj");
                        if (map) {
                            google.maps.event.trigger(map, 'resize');
                            if (place.geometry.location) {
                                map.setCenter(place.geometry.location);
                                var addressMarker = $(mapElem).data("autocomplete-marker");
                                if (addressMarker) {
                                    addressMarker.setPosition(place.geometry.location);
                                    addressMarker.setMap(map);
                                }
                            }
                            else if (place.geometry.viewport) {
                                map.fitBounds(place.geometry.viewport);
                            }
                        }
                    }
                    $(inputElem).trigger("mcd:autocomplete", { location: convertPlace(place), result: place });
                });
            }
        }
        Map.InitAutoComplete = InitAutoComplete;
        function InitMap(mapElem, latLng, options) {
            var map = $(mapElem).data("map-obj");
            if (!map) {
                var zoom = 13;
                if (options && options.zoom) {
                    zoom = options.zoom;
                }
                $(mapElem).data("map-zoom", zoom);
                var mapOptions = void 0;
                if (latLng && latLng.lat && latLng.lng) {
                    mapOptions = $.extend({ zoom: zoom, center: latLng }, options);
                }
                else {
                    mapOptions = $.extend({ zoom: australiaZoom, center: australiaLatLng }, options);
                }
                var MY_MAPTYPE_ID = 'custom_style';
                mapOptions = $.extend({
                    mapTypeControlOptions: { style: google.maps.ZoomControlStyle.SMALL, mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID] },
                    mapTypeId: MY_MAPTYPE_ID
                }, mapOptions);
                map = new google.maps.Map($(mapElem)[0], mapOptions);
                var styledMapOptions = { name: 'Custom' };
                var customMapType = new google.maps.StyledMapType(GetStandardMapStyle(), styledMapOptions);
                map.mapTypes.set(MY_MAPTYPE_ID, customMapType);
                $(mapElem).data("map-obj", map);
            }
            return map;
        }
        Map.InitMap = InitMap;
        function AddMarker(mapElem, latLng, options) {
            var map = $(mapElem).data("map-obj");
            if (!map)
                throw "Map not initialised";
            var markerOptions = $.extend({
                position: latLng,
                map: map,
                icon: addressIcon,
                draggable: false,
                autocomplete: true
            }, options);
            var addressMarker = new google.maps.Marker(markerOptions);
            if (markerOptions.draggable) {
                google.maps.event.addListener(addressMarker, 'dragend', function (e) {
                    $(mapElem).trigger("mcd:marker-drag", { marker: addressMarker, latLng: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
                });
            }
            if (markerOptions.autocomplete) {
                $(mapElem).data("autocomplete-marker", addressMarker);
            }
            return addressMarker;
        }
        Map.AddMarker = AddMarker;
        function SetMarker(marker, latLng) {
            if (marker && latLng && latLng.lat && latLng.lng) {
                marker.setPosition(latLng);
            }
        }
        Map.SetMarker = SetMarker;
        function SetCentre(mapElem, latLng) {
            var map = $(mapElem).data("map-obj");
            if (!map)
                throw "Map not initialised";
            if (latLng && latLng.lat && latLng.lng) {
                map.setCenter(latLng);
                map.setZoom($(mapElem).data("map-zoom"));
            }
        }
        Map.SetCentre = SetCentre;
        function SetDraggable(marker, draggable) {
            marker.setDraggable(draggable);
        }
        Map.SetDraggable = SetDraggable;
        function GetAddressForPoint(latLng, onSuccess, onFail) {
            var geocoder = new google.maps.Geocoder();
            var req = {};
            req.location = latLng;
            geocoder.geocode(req, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (onSuccess) {
                        onSuccess({ location: convertGeocoder(results[0]), results: results, status: status });
                    }
                }
                else {
                    if (onFail) {
                        onFail({ results: results, status: status });
                    }
                    else {
                        alert('We were unable to determine the address for the new location: ' + status);
                    }
                }
            });
        }
        Map.GetAddressForPoint = GetAddressForPoint;
        function GetPointForAddress(address, onSuccess, onFail) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: address }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (onSuccess) {
                        onSuccess({ location: convertGeocoder(results[0]), results: results, status: status });
                    }
                }
                else {
                    if (onFail) {
                        onFail({ results: results, status: status });
                    }
                    else {
                        alert('We were unable to determine the location from the address: ' + status);
                    }
                }
            });
        }
        Map.GetPointForAddress = GetPointForAddress;
        function GeocodeAddress(address, mapElem, marker) {
            var map = $(mapElem).data("map-obj");
            if (!map)
                throw "Map not initialised";
            GetPointForAddress(address, function (data) {
                if (data.location.latLng) {
                    SetMarker(marker, data.location.latLng);
                    $(mapElem).trigger("mcd:marker-move", { marker: marker, location: data.location });
                }
                else {
                    alert("We are unable to pinpoint your location from the supplied address");
                }
            });
        }
        Map.GeocodeAddress = GeocodeAddress;
        function DistanceBetween(latLng1, latLng2) {
            return getDistanceBetweenPoints(latLng1.lat(), latLng1.lng(), latLng2.lat(), latLng2.lng());
        }
        Map.DistanceBetween = DistanceBetween;
        function LoadMapMarkers(mapName, results, showResourceList, searchCenter) {
            window.MapView = Common.Map.InitMap(mapName);
            window.Bounds = new google.maps.LatLngBounds();
            // Clear out any existing map markers
            if (window.Markers && window.Markers.length > 0) {
                window.Markers.forEach(function (marker, i, array) {
                    marker.setMap(null);
                });
            }
            window.Markers = [];
            window.InfoWindow = new google.maps.InfoWindow({});
            // Clear out the council map if used.
            if (typeof window.CouncilLayer !== 'undefined') {
                window.CouncilLayer.setMap(window.MapView);
            }
            var markerHandler = function () {
                window.InfoWindow.setContent(this.html);
                window.InfoWindow.open(window.MapView, this);
            };
            window.Markers = results.filter(function (listing, i, array) {
                return listing.Outlet.MapLocation.ShowMarker;
            }).map(function (listing, i, array) {
                var html = "<div class='google-result'><div class='contact-details'>";
                if (showResourceList) {
                    var phone = listing.Outlet.Phone || "";
                    var pstripped = phone.replace(/[^0-9]+/g, "");
                    if (pstripped.length > 0) {
                        html += "<p class='icon icon-phone60'><a href='tel:" + pstripped + "'>" + phone + "</a></p>";
                    }
                    else if (phone.substr(0, 2) === "--") {
                        html += "<p class='icon icon-phone60'>" + value + "</p>";
                    }
                    var value = listing.Outlet.DisplayAddress || "";
                    var inner = "--not supplied--";
                    if (value.length > 0) {
                        if (value.substr(0, 2) === "--") {
                            inner = value;
                        }
                        else {
                            inner = "<a href='https://maps.google.com/?q=" + encodeURIComponent(value) + "' target='_blank'>" + value + "</a>";
                        }
                    }
                    html += "<p class='icon icon-map15'>" + inner + "</p>";
                }
                else {
                    html += "<p class='icon icon-phone60'><a href='" + listing.Url + "' class='btn btn-small btn-blue'>Contact Us</a></p>";
                    html += "<p class='icon icon-map15'>" + listing.Outlet.Suburb + "</p>";
                }
                if (searchCenter !== 'undefined' && searchCenter !== '') {
                    html += "<p class='icon icon-podcast distance'>" + listing.Distance + " from the centre of " + searchCenter + "</p>";
                }
                if (listing.Outlet.LookingForVolunteer === Common.LookingForVolunteer.Yes) {
                    html += "<p class='icon icon-user58'><a href='".concat(listing.Url, "' style='color: #d14905' class='nofollow'>We currently have (THE NUMBER OF POSITION) volunteer positions available. Click here for further information</a></p>");
                }
                if (listing.Outlet.LookingForVolunteer === Common.LookingForVolunteer.Maybe) {
                    html += "<p class='icon icon-user58'><a href='" + listing.Url + "' style='color: #d14905' class='nofollow'>We may have volunteer positions available for the right person. Click here for further information</a></p>";
                }
                html += "</div></div>";
                var markerPos = new google.maps.LatLng(listing.Outlet.MapLocation.Lat, listing.Outlet.MapLocation.Lng);
                var marker = new google.maps.Marker({
                    position: markerPos,
                    map: window.MapView,
                    icon: "/_static/images/map_marker.png",
                    html: "<h3 class=\"h5 orange\"><a href=\"".concat(listing.Url, "\">").concat(listing.Outlet.Nickname, "</a></h3>").concat(html)
                });
                window.Bounds.extend(markerPos);
                google.maps.event.addListener(marker, 'click', markerHandler);
                return marker;
            });
            //for (i = 0; i < results.length; i++) {
            //    // An example marker
            //    var listing = results[i];
            //    var html = "<div class='google-result'><div class='contact-details'>";
            //    if (showResourceList) {
            //        var phone = listing.Outlet.Phone || "";
            //        var pstripped = phone.replace(/[^0-9]+/g, "");
            //        if (pstripped.length > 0) {
            //            html += "<p class='icon icon-phone60'><a href='tel:" + pstripped + "'>" + phone + "</a></p>";
            //        }
            //        else if (phone.substr(0, 2) === "--") {
            //            html += "<p class='icon icon-phone60'>" + value + "</p>";
            //        }
            //        var value = listing.Outlet.DisplayAddress || "";
            //        var inner = "--not supplied--";
            //        if (value.length > 0) {
            //            if (value.substr(0, 2) === "--") {
            //                inner = value;
            //            }
            //            else {
            //                inner = "<a href='https://maps.google.com/?q=" + encodeURIComponent(value) + "' target='_blank'>" + value + "</a>";
            //            }
            //        }
            //        html += "<p class='icon icon-map15'>" + inner + "</p>";
            //    }
            //    else {
            //        html += "<p class='icon icon-phone60'><a href='" + listing.Url + "' class='btn btn-small btn-blue'>Contact Us</a></p>";
            //        html += "<p class='icon icon-map15'>" + listing.Outlet.Suburb + "</p>";
            //    }
            //    if (searchCenter !== 'undefined' && searchCenter !== '') {
            //        html += "<p class='icon icon-podcast distance'>" + listing.Distance + " from the centre of " + searchCenter + "</p>";
            //    }
            //    html += "</div></div>";
            //    if (listing.Outlet.MapLocation.ShowMarker) {
            //        var markerPos = new google.maps.LatLng(listing.Outlet.MapLocation.Lat, listing.Outlet.MapLocation.Lng);
            //        var marker = new google.maps.Marker({
            //            position: markerPos,
            //            map: window.Map,
            //            icon: "/_static/images/map_marker.png",
            //            html: `<h3 class="h5 orange"><a href="${listing.Url}">${listing.Outlet.Nickname}</a></h3>${html}`
            //        });
            //        bounds.extend(markerPos);
            //        google.maps.event.addListener(marker, 'click', markerHandler);
            //        window.Markers[window.Markers.length] = marker;
            //    }
            //}
            if (window.Markers.length === 0) {
                if (window.CurrentCouncil) {
                    window.CouncilLayer = new google.maps.KmlLayer({ url: window.CurrentCouncil.KmlLocation });
                    window.CouncilLayer.setMap(window.MapView);
                }
            }
            else {
                FitMapBounds(window.MapView, window.Bounds);
            }
        }
        Map.LoadMapMarkers = LoadMapMarkers;
        function FitMapBounds(map, bounds) {
            map.fitBounds(bounds);
            google.maps.event.addListenerOnce(window.MapView, 'bounds_changed', function (event) {
                if (this.getZoom() > 17) {
                    this.setZoom(17);
                }
            });
        }
        Map.FitMapBounds = FitMapBounds;
        function GetStandardMapStyle() {
            var featureOpts = [
                { featureType: "water", stylers: [{ saturation: -63 }] },
                { featureType: "road", stylers: [{ saturation: -100 }] },
                { featureType: "administrative.province", elementType: "labels.text", stylers: [{ hue: "#dd00ff" }, { weight: 1.2 }] },
                { featureType: "poi.government", stylers: [{ saturation: -100 }] },
                { featureType: "poi.business", stylers: [{ saturation: -100 }] },
                { featureType: "poi.government", stylers: [{ saturation: -100 }] },
                { featureType: "poi.medical", stylers: [{ saturation: -100 }] },
                { featureType: "poi.place_of_worship", stylers: [{ saturation: -100 }] },
                { featureType: "poi.school", stylers: [{ saturation: -100 }] },
                { featureType: "poi.sports_complex", stylers: [{ saturation: -100 }] },
                { featureType: "water", stylers: [{ saturation: 44 }] },
                { featureType: "administrative.locality" }
            ];
            return featureOpts;
        }
        Map.GetStandardMapStyle = GetStandardMapStyle;
        function GetCustomStyle() {
            var featureOpts = [
                {
                    featureType: "water", elementType: 'geometry.fill', stylers: [{
                            color: '#d3d3d3',
                        }]
                },
                {
                    featureType: 'transit',
                    stylers: [
                        {
                            color: '#808080',
                        },
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#b3b3b3',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#ffffff',
                        },
                        {
                            weight: 1.8,
                        },
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#d7d7d7',
                        },
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#ebebeb',
                        },
                    ]
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#a7a7a7',
                        },
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ]
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#efefef',
                        },
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#696969',
                        },
                    ]
                },
                {
                    featureType: 'administrative',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            visibility: 'on',
                        },
                        {
                            color: '#737373',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                }
            ];
            return featureOpts;
        }
        Map.GetCustomStyle = GetCustomStyle;
    })(Map = Common.Map || (Common.Map = {}));
})(Common || (Common = {}));
